import React from "react";
import { Modal, Form, Input, Button, notification } from "antd";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createSpecSection } from "../services/specSectionsAPI";
import { useAuth } from "../hooks/useAuth";

const CreateSpecSectionModal = ({ visible, onClose, onSpecSectionCreated }) => {
  const { selectedProject } = useAuth();
  const projectId = selectedProject.project_id;
  const queryClient = useQueryClient();
  const [form] = Form.useForm();

  const mutation = useMutation({
    mutationFn: createSpecSection,
    onSuccess: (created) => {
      queryClient.invalidateQueries(["specSections", projectId]);
      onSpecSectionCreated?.(created);
      onClose();
      form.resetFields();
      notification.success({ message: "Spec Section created successfully" });
    },
    onError: (error) => {
      notification.error({
        message: "Failed to create Spec Section",
        description:
          error.response?.data?.detail || error.message || "Unknown error",
      });
    },
  });

  const handleCreateSpecSection = (values) => {
    const specSectionData = {
      ...values,
      project_id: projectId,
    };
    mutation.mutate(specSectionData);
  };

  const handleClose = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      title="Create Spec Section"
      open={visible}
      onCancel={handleClose}
      footer={null}
    >
      <Form form={form} onFinish={handleCreateSpecSection} layout="vertical">
        <Form.Item
          label="Section Number"
          name="section_number"
          rules={[
            { required: true, message: "Please input the section number!" },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Title"
          name="title"
          rules={[{ required: true, message: "Please input the title!" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={mutation.isPending}
            style={{ width: "100%" }}
          >
            Create Spec Section
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateSpecSectionModal;
